import { UserTypes } from 'types/GlobalTypes';
import { UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';

export const StatusCodes = {
  Success: 200,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
};

export const TypeColorsDictionary: Record<UserTypes | string, string> = {
  admin: 'black',
  analyst: 'dark-periwinkle',
  scout: 'kermit-green',
  trainer: 'ballPlayerBLue',
  coach: 'sky-blue',
  player: 'orange',
  stadiumtagger: 'stadiumTagger',
  cloudlivedashboard: 'cloudLiveDashboard',
  user: 'reddish-pink',
  other: 'reddish-pink',

  // status
  active: 'success',
  pending: 'primary',
  pendinguseraction: 'primary',
  pendingappsetup: 'primary',
  pendingemailsend: 'primary',
  inactive: 'secondary',
  abandoned: 'secondary',
  finalized: 'black',
};

export const UserDiagnosticsStateColorsDictionary: Record<UserDiagnosticsState, string> = {
  [UserDiagnosticsState.New]: 'sky-blue',
  [UserDiagnosticsState.Tracked]: 'orange',
  [UserDiagnosticsState.Closed]: 'black',
};

export const UserDiagnosticsTagColorsDictionary: Record<UserDiagnosticsTag, string> = {
  [UserDiagnosticsTag.Crash]: 'ballPlayerRed',
  [UserDiagnosticsTag.NoTrigger]: 'ballPlayerMint',
  [UserDiagnosticsTag.Tracking]: 'ballPlayerPurple',
  [UserDiagnosticsTag.Connection]: 'ballPlayerYellow',
};

export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  apiServiceAxiosInstance: Symbol('apiServiceAxiosInstance'),
  PortalBackendService: Symbol('PortalBackendService'),
};

export const AppPermissions = {
  // Main permissions
  PortalAccess: ['AFB.AdminPortalAccess@AFB'],
};

export const TrackingDiagnosticsTypePalette: string[] = [
  'sky-blue',
  'ballPlayerBlue',
  'ballPlayerPurple',
  'ballPlayerRed',
  'ballPlayerMint',
  'ballPlayerYellow',
  'orange',
  'kermit-green',
  'reddish-pink',
  'black',
];

export const DefaultTrackingDiagnosticTypeColor = 'black';

export const TrackingDiagnosticsSessionTypePalette: string[] = [
  'optimizerBlue',
  'ballPlayerYellow',
  'ballPlayerBlue',
  'kermit-green',
  'ballPlayerRed',
  'reddish-pink',
  'ballPlayerMint',
  'orange',
  'ballPlayerPurple',
  'sky-blue',
];

export const DefaultTrackingDiagnosticSessionTypeColor = 'black';

export const BooleanColorsDictionary: Record<string, string> = {
  true: 'success',
  false: 'warning-red',
  null: 'ballPlayerYellow',
};
